import { computed, defineComponent } from 'vue';
import { EditorNodeEmptyState } from '@getaccept/editor-lib-new';
import { t } from '@getaccept/lib-shared-new/src/helpers/translation.helper';
export default defineComponent({
    components: {
        EditorNodeEmptyState,
    },
    props: {
        node: {
            type: Object,
            required: true,
        },
        placeholder: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const hasPlaceholder = computed(() => { var _a, _b; return !!((_b = (_a = props.node.placeholder) === null || _a === void 0 ? void 0 : _a.resourceIds) === null || _b === void 0 ? void 0 : _b.length); });
        const emptyStateDescription = computed(() => hasPlaceholder.value ? null : t('content_placeholder_is_empty_view_only'));
        const isResourceUnavailable = (resource) => {
            const isDeleted = 'deletedAt' in resource && resource.deletedAt !== null;
            const isContentIdMissing = !resource.contentId;
            return isDeleted || isContentIdMissing;
        };
        return {
            t,
            hasPlaceholder,
            emptyStateDescription,
            isResourceUnavailable,
        };
    },
});
